import React from "react";

function Footer() {
  return (
    <footer>
      <p>&copy; 2025 Mon Portfolio</p>
    </footer>
  );
}

export default Footer;
